<template>
  <div>
    <el-dialog
      class="user-bank-form-dialog"
      :visible.sync="visible"
      :fullscreen="false"
      :before-close="closeDialog">
      <template slot="title">
        {{ title }}
      </template>
      <el-form ref="form"
               :model="form"
               size="medium"
               :rules="formRules"
               label-width="120px">

        <el-form-item label="用户名"
                      key="user_id"
                      prop="user_id">
          <remote-select
            :disabled="id > 0"
            class="width-max"
            clearable
            id-key="id"
            keyword-key="name"
            label-key="name"
            value-key="id"
            placeholder="请输入用户名搜索"
            v-model="form.user_id"
            @change="chooseUser"
            :query-request="(_)=>getPlatformUsersList(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1}))"
            :find-request="getCurrentUsersDetail">
          </remote-select>
        </el-form-item>

        <el-form-item label="部门"
                      key="department_id"
                      prop="department_id">
          <remote-select
            class="width-max"
            clearable
            id-key="id"
            keyword-key="name"
            label-key="name"
            value-key="id"
            placeholder="请选择部门"
            v-model="form.department_id"
            @change="form.department_job_id = null"
            :query-request="getFinCenterDepartmentList"
            :find-request="getFinCenterDepartmentDetail">
          </remote-select>
        </el-form-item>

        <el-form-item label="岗位"
                      prop="department_job_id">
          <remote-select
            class="width-max"
            clearable
            id-key="id"
            keyword-key="name"
            label-key="name"
            value-key="id"
            placeholder="请选择岗位"
            v-model="form.department_job_id"
            :disabled="!form.department_id"
            :query-params="{department_id: form.department_id}"
            :query-request="getDepartmentJobLists"
            :find-request="getDepartmentJobDetail">
          </remote-select>
        </el-form-item>

        <el-form-item label="员工姓名"
                      key="realname"
                      prop="realname">
          <el-input v-model="form.realname"
                    placeholder="请输入员工姓名" />
        </el-form-item>

        <el-form-item label="一级审批人"
                      key="first_approver"
                      prop="first_approver">
          <remote-select
            class="width-max"
            clearable
            id-key="id"
            keyword-key="name"
            label-key="name"
            value-key="id"
            placeholder="请输入一级审批人名称搜索"
            v-model="form.first_approver"
            :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1}))"
            :find-request="getPlatformUsersDetail">
          </remote-select>
        </el-form-item>

        <el-form-item label="二级审批人"
                      key="second_approver"
                      prop="second_approver">
          <remote-select
            class="width-max"
            clearable
            id-key="id"
            keyword-key="name"
            label-key="name"
            value-key="id"
            placeholder="请输入二级审批人名称搜索"
            v-model="form.second_approver"
            :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1}))"
            :find-request="getPlatformUsersDetail">
          </remote-select>
        </el-form-item>

        <el-form-item label="三级审批人"
                      key="third_approver"
                      prop="third_approver">
          <remote-select
            class="width-max"
            clearable
            id-key="id"
            keyword-key="name"
            label-key="name"
            value-key="id"
            placeholder="请输入三级审批人名称搜索"
            v-model="form.third_approver"
            :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1}))"
            :find-request="getPlatformUsersDetail">
          </remote-select>
        </el-form-item>

        <el-form-item label="四级审批人"
                      key="fourth_approver"
                      prop="fourth_approver">
          <remote-select
            class="width-max"
            clearable
            id-key="id"
            keyword-key="name"
            label-key="name"
            value-key="id"
            placeholder="请输入四级审批人名称搜索"
            v-model="form.fourth_approver"
            :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1}))"
            :find-request="getPlatformUsersDetail">
          </remote-select>
        </el-form-item>

        <el-form-item label="账户名称"
                      prop="name"
                      key="name">
          <el-input style="width: 100%;"
                    :disabled="id > 0"
                    v-model="form.name"
                    clearable
                    placeholder="请输入账户名称">
          </el-input>
        </el-form-item>

        <el-form-item label="银行账号"
                      prop="bank_account"
                      key="bank_account">
          <el-input style="width: 100%;"
                    :disabled="id > 0"
                    v-model="form.bank_account"
                    clearable
                    placeholder="请输入银行账号">
          </el-input>
        </el-form-item>

        <el-form-item label="开户银行支行"
                      prop="bank"
                      key="bank">
          <el-input style="width: 100%;"
                    :disabled="id > 0"
                    v-model="form.bank"
                    clearable
                    placeholder="请输入开户银行支行">
          </el-input>
        </el-form-item>

        <el-form-item label="开户银行总行"
                      prop="bank_headquarters"
                      key="bank_headquarters">
          <el-input style="width: 100%;"
                    :disabled="id > 0"
                    v-model="form.bank_headquarters"
                    clearable
                    placeholder="请输入开户银行总行">
          </el-input>
        </el-form-item>

        <div style="margin:0 auto; text-align:right;">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary"
                     @click="onSubmit()">保存
          </el-button>
        </div>

      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import { formRules } from '../user-bank-account.rules.js'

export default {
  data () {
    return {
      formRules,
      form: {
        'user_id': null,
        'user_name': null,
        'department_id': null,
        'department_job_id': null,
        'name': null,
        'realname': null,
        'bank_account': null,
        'bank': null,
        'bank_headquarters': null,
        'first_approver': null,
        'second_approver': null,
        'third_approver': null,
        'fourth_approver': null,
      },
      user_list: [],
    }
  },
  props: {
    visible: Boolean,
    title: String,
    id: Number,
  },
  watch: {
    id: {
      handler (val) {
        if (val > 0) {
          this.setForm(val)
        } else {
          Object.assign(this.$data, this.$options.data.call(this))
        }
      },
    },
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
    }),
  },
  methods: {
    ...request.map(['getDepartmentJobLists', 'getDepartmentJobDetail']),
    ...Vuex.mapActions(['getPlatformUsersDetail', 'getPlatformUsersIndex']),
    closeDialog () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$emit('closeDialog')
    },
    closeDialogRefresh () {
      this.$emit('closeDialogRefresh')
    },
    setForm (id) {
      request.page('getUserBankAccountById', {id}).then(({data}) => {
        filter.setLoop(this.form, data)
      })
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.checkSubmit()) {
            this.id ? this.updateUserBank(this.id) : this.createUserBank()
          }
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    checkSubmit () {
      if (this.id * 1 === 0) {
        for (let i = 0; i < this.user_list.length; i++) {
          if (this.user_list[i].id * 1 === this.form.user_id * 1) {
            this.form.user_name = this.user_list[i].name
            break
          }
        }
      }
      if (!this.form.user_name) {
        this.$message.error('请选择用户名')
        return false
      }
      return true
    },
    createUserBank () {
      request.common('createUserBankAccount', {...this.getForm()}).then((res) => {
        this.$confirm('添加员工账户信息成功, 是否关闭弹层？', '提示', {type: 'success'}).then(() => {
          this.closeDialogRefresh()
        })
      })
    },
    updateUserBank (id) {
      request.common('updateUserBankAccount', {id, ...this.getForm()}).then((res) => {
        this.$confirm('修改员工账户信息成功, 是否关闭弹层？', '提示', {type: 'success'}).then(() => {
          this.closeDialogRefresh()
        })
      })
    },
    getForm () {
      return filter.copyJson(this.form)
    },
    getPlatformUsersList (query) {
      return request.common('getPlatformUsersIndex', query).then((res) => {
        this.user_list = res.data.data
        return res
      })
    },
    getCurrentUsersDetail (id) {
      return request.common('getPlatformUsersDetail', id).then(res => {
        this.form.user_name = res.data.name
        return res
      })
    },
    chooseUser (user) {
      request.common('getuserAccountDetailByUserID', {id: user.id}).then(({data}) => {
        const tempUser = data.pop()
        if (tempUser) {
          this.form.first_approver = tempUser.first_approver
          this.form.second_approver = tempUser.second_approver
          this.form.third_approver = tempUser.third_approver
          this.form.fourth_approver = tempUser.fourth_approver
          this.form.department_id = tempUser.department_id
          this.form.department_job_id = tempUser.department_job_id
          this.form.realname = tempUser.realname
        }
      })
    },
    getFinCenterDepartmentList () {
      return request.common('getFinCenterDepartmentTableList', {per_page: 100, is_disabled: 0})
    },
    getFinCenterDepartmentDetail () {
      return request.common('getFinCenterDepartmentDetail', {id: this.form.department_id})
    },
  }
}
</script>


<style scoped>

.user-bank-form-dialog >>> .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 600px;
  transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

.user-bank-form-dialog >>> .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/user-bank-account/components/UserBankFormDialog.vue